// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> the-station
// Generated: 2026-10-08T21:19:02.332Z
// Counts: 1 design, 67 content, 41 slot group, 6 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Studio, 1 and 2  Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "VALUE",
    "customValue": "Studio, 1 and 2",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Station in Littleton, CO, every detail caters to your lifestyle. Choose from stylish studios to spacious two-bedroom apartments, featuring stainless steel appliances, walk-in closets, and private balconies. With ample storage and a smoke-free environment, comfort and convenience are at your fingertips—perfectly located just a stroll from campus!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Dogs and cats allowed. $300 deposit. $35 monthly pet rent.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-3594-7128-8c94-9665ac6434f5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior building view with balconies and landscaping at The Station apartments in downtown Littleton, CO."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-100b-76b8-b314-c0ddfcfaff73.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dog park with agility equipment including tunnels and hoops at The Station apartments in downtown Littleton, CO."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a951-74fe-a1ed-7bc53833b447.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building exterior at dusk with illuminated windows and balconies at The Station apartments in downtown Littleton, CO."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-3594-7128-8c94-9665ac6434f5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior building view with balconies and landscaping at The Station apartments in downtown Littleton, CO."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019fa965-69ee-73c9-a80e-e91476c5f835.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Elegant wine glasses and cozy restaurant ambiance create a sophisticated dining experience."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a96f-7083-b996-9305badd35c8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings and surrounding neighborhood with mountains in the background."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-10ce-708e-b383-e9cca1916642.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with wood floors and a sliding glass door to a balcony at The Station apartments in downtown Littleton, CO."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02cf-9d48-727e-a733-3f0da9f845eb.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-2a0f-7336-86f2-822566d52eb6.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-dd27-747c-87b5-c0ef4701bd7b.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a951-74fe-a1ed-7bc53833b447.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The Station apartments in Littleton, CO at dusk, with warm, illuminated windows and private balconies against the evening sky."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166795/019f8070-de76-71dd-a232-76cebf731fa1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a multifamily property with multiple buildings, parking lots, and a distant cityscape."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-2e8a-725e-b098-8a5667379992.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of The Station Apartments building with a monument sign and trees."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019fa966-ae79-7163-b0bf-9164911e976f.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "High angle of anonymous young female traveler in casual outfit and backpack walking along promenade near river streaming through city park on sunny day"
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019fa967-e27e-77ec-bec1-0b8390926c1f.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Back view of a man jogging with his dog on a sunny morning in an English park."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166795/019f8070-a96f-7083-b996-9305badd35c8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of The Station apartment buildings set within the Littleton, CO neighborhood with mountains on the horizon."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-caf3-744c-a3e9-9f2a08b3b21c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Walkway between apartment buildings with trees and landscaping at The Station apartments in downtown Littleton, CO."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-ca1a-7388-8f23-022562547b23.webp"
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a951-74fe-a1ed-7bc53833b447.webp"
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166795/019f8070-a9a3-70f4-88db-1f491096f756.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166795/019fa96d-aa66-722c-a1db-d13c22435b0b.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-f2e5-74dd-82d3-e6350119e560.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-0f51-7778-9a7a-710f5eebd3fa.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-e0d4-742e-8dfb-b03ac46fba78.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a91b-73d9-976e-1d938c93c1c1.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-c8d7-702d-868b-cd2ef6811122.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-caf3-744c-a3e9-9f2a08b3b21c.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-2e8a-725e-b098-8a5667379992.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of The Station Apartments building with a monument sign and trees."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166795/019fa96d-aa66-722c-a1db-d13c22435b0b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Couple walking down a tree-lined path on a sunny day."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a951-74fe-a1ed-7bc53833b447.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building exterior at dusk with illuminated windows and balconies at The Station apartments in downtown Littleton, CO."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a951-74fe-a1ed-7bc53833b447.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building exterior at dusk with illuminated windows and balconies at The Station apartments in downtown Littleton, CO."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166795/019fa96d-aa66-722c-a1db-d13c22435b0b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Couple walking together down a sunny tree-lined path near The Station apartments in Littleton, CO"
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-0fb4-7340-be3a-3c35bb294add.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room with modern kitchen and sliding glass door at The Station apartments in downtown Littleton, CO."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": [
      "custom_1baae0fc-2427-410f-9e00-496a756772df",
      "custom_5503a329-a6c3-4409-8b76-c39ea9162d17",
      "custom_ea07c41f-e65c-4a97-b3a4-2ea8699f7673"
    ],
    "orderedIds": [
      "custom_ae6ab09e-5fd1-4dc9-87de-292339ea1388",
      "custom_47b82fc0-17e1-45d8-8047-ef5132a2ed9b",
      "custom_ba306fd4-b9e6-461d-8e6c-bf948eae82c4",
      "custom_ccae5992-16d7-4492-abc4-0ccc0569235c",
      "custom_0788cd80-dbaa-4d80-9887-7f6a88518c2a",
      "custom_7c0db371-f7ba-47e5-82d6-03544c9c54b5",
      "custom_1baae0fc-2427-410f-9e00-496a756772df",
      "custom_cca7677e-3e4b-4e56-b8bc-174845f0fdc7",
      "custom_86da08e7-49a8-494e-b330-9f3e7faf756d",
      "custom_3799de94-7466-4956-b8c9-c908a484d4f7",
      "custom_5503a329-a6c3-4409-8b76-c39ea9162d17",
      "custom_76823493-eccb-4049-8b45-262194da87e6",
      "custom_af625cbd-9152-4ed5-ba48-bc6fb3a2181b",
      "custom_ea07c41f-e65c-4a97-b3a4-2ea8699f7673",
      "custom_f5be979e-5744-441b-9e6a-fc546ce745a8",
      "custom_39714e35-5fae-432e-9bf8-7cab6fdd048d",
      "custom_53505aa5-9be3-4f0e-851b-f9fd5c6d026b",
      "custom_75f025c9-6112-4ccf-aebe-a346ceb524eb",
      "custom_4a18bb49-36b0-442b-a617-9146cb9d344a",
      "custom_bbfb616c-7ef5-458e-b2ee-f62be93b25c2",
      "custom_cf03f851-2ca3-411c-aaa0-5d851fc208cd",
      "custom_a35563c5-0232-4c36-80fc-8925b3b13910",
      "custom_e65a5a53-a4e5-4931-abeb-32b00852ad4a",
      "custom_007743f4-1348-4400-9d8c-369a6bb9c505",
      "custom_bef2517d-6a7c-4e7e-8eb6-9c9783b388a4",
      "custom_9c26a789-fbd1-4487-9f69-a8a20625aca9",
      "custom_9f542a7d-44fb-4419-92fe-9fd4aec03c74",
      "custom_29eaeff8-67a7-4174-a29b-0d30098d647b",
      "custom_5da2faae-9d56-408d-9dc5-b65bda942734",
      "custom_fb2a1824-ed63-4345-96a5-062a9a2aaf75",
      "custom_4d6f6556-6854-4ae8-baa4-311398f546e8",
      "custom_d0183d22-0b9d-4895-8889-2567b45fd90e",
      "custom_0551ad4a-3654-4cf0-b18c-82c4b7d8434c",
      "custom_106a5140-4817-42d2-ba66-49546bdcd3c2",
      "custom_3d56ff79-e4c7-42dd-916f-d4a07447667a",
      "custom_ec42de81-9899-435a-87ab-b4fbbda722eb",
      "custom_11559b4a-51d9-4343-96a2-3a4e151c80b2",
      "custom_210e779d-1cb0-49a9-8544-4661e6672b39",
      "custom_83457af3-ea96-48eb-b1ab-22e8f3586e34"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_1baae0fc-2427-410f-9e00-496a756772df",
      "custom_ba306fd4-b9e6-461d-8e6c-bf948eae82c4",
      "custom_af625cbd-9152-4ed5-ba48-bc6fb3a2181b",
      "custom_5503a329-a6c3-4409-8b76-c39ea9162d17",
      "custom_9f542a7d-44fb-4419-92fe-9fd4aec03c74",
      "custom_cca7677e-3e4b-4e56-b8bc-174845f0fdc7",
      "custom_ea07c41f-e65c-4a97-b3a4-2ea8699f7673",
      "custom_f5be979e-5744-441b-9e6a-fc546ce745a8",
      "custom_75f025c9-6112-4ccf-aebe-a346ceb524eb",
      "custom_3799de94-7466-4956-b8c9-c908a484d4f7",
      "custom_26c34bb5-a2c9-4280-9c47-53a9f22b86af",
      "custom_53505aa5-9be3-4f0e-851b-f9fd5c6d026b",
      "custom_bef2517d-6a7c-4e7e-8eb6-9c9783b388a4",
      "custom_4cb6d2e7-b687-4058-80b6-6ccb788f5339",
      "custom_fb2a1824-ed63-4345-96a5-062a9a2aaf75",
      "custom_d0183d22-0b9d-4895-8889-2567b45fd90e",
      "custom_106a5140-4817-42d2-ba66-49546bdcd3c2",
      "custom_3d56ff79-e4c7-42dd-916f-d4a07447667a",
      "custom_ec42de81-9899-435a-87ab-b4fbbda722eb"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_86da08e7-49a8-494e-b330-9f3e7faf756d",
      "custom_0788cd80-dbaa-4d80-9887-7f6a88518c2a",
      "custom_ccae5992-16d7-4492-abc4-0ccc0569235c",
      "custom_29eaeff8-67a7-4174-a29b-0d30098d647b",
      "custom_47b82fc0-17e1-45d8-8047-ef5132a2ed9b",
      "custom_39714e35-5fae-432e-9bf8-7cab6fdd048d",
      "custom_ae6ab09e-5fd1-4dc9-87de-292339ea1388",
      "custom_eb930bdb-cab7-477d-b1fc-127dc26a9ce7",
      "custom_bbfb616c-7ef5-458e-b2ee-f62be93b25c2",
      "custom_09830d65-0d5e-4518-8b96-2ce453ecdb74",
      "custom_a35563c5-0232-4c36-80fc-8925b3b13910",
      "custom_3085280c-ed4a-4642-928c-b35bf235b2cf",
      "custom_7c0db371-f7ba-47e5-82d6-03544c9c54b5",
      "custom_e65a5a53-a4e5-4931-abeb-32b00852ad4a",
      "custom_76823493-eccb-4049-8b45-262194da87e6",
      "custom_007743f4-1348-4400-9d8c-369a6bb9c505",
      "custom_9c26a789-fbd1-4487-9f69-a8a20625aca9",
      "custom_5da2faae-9d56-408d-9dc5-b65bda942734",
      "custom_4d6f6556-6854-4ae8-baa4-311398f546e8",
      "custom_0551ad4a-3654-4cf0-b18c-82c4b7d8434c",
      "custom_0925372c-c4ac-4463-99e7-a105f8419558",
      "custom_fa65b0ab-c463-4ad0-af57-a4b46a365c14",
      "custom_976363ad-7c96-41e8-bb9a-c2400ada1fe1",
      "custom_fc7f9751-fb97-4352-9ca9-5ef8367f893b",
      "custom_11559b4a-51d9-4343-96a2-3a4e151c80b2",
      "custom_cf03f851-2ca3-411c-aaa0-5d851fc208cd",
      "custom_210e779d-1cb0-49a9-8544-4661e6672b39",
      "custom_83457af3-ea96-48eb-b1ab-22e8f3586e34",
      "custom_fdf5fc64-6ae0-4675-aa2b-1dd6f2bc608b",
      "custom_36a9e2f5-7510-4240-aa48-87ec74d6d6cb"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_210e779d-1cb0-49a9-8544-4661e6672b39",
      "custom_4d6f6556-6854-4ae8-baa4-311398f546e8",
      "custom_0551ad4a-3654-4cf0-b18c-82c4b7d8434c",
      "custom_e65a5a53-a4e5-4931-abeb-32b00852ad4a",
      "custom_bbfb616c-7ef5-458e-b2ee-f62be93b25c2",
      "custom_106a5140-4817-42d2-ba66-49546bdcd3c2",
      "custom_3d56ff79-e4c7-42dd-916f-d4a07447667a",
      "custom_3799de94-7466-4956-b8c9-c908a484d4f7",
      "custom_9f542a7d-44fb-4419-92fe-9fd4aec03c74",
      "custom_ea07c41f-e65c-4a97-b3a4-2ea8699f7673",
      "custom_39714e35-5fae-432e-9bf8-7cab6fdd048d"
    ],
    "orderedIds": [
      "custom_0788cd80-dbaa-4d80-9887-7f6a88518c2a",
      "custom_47b82fc0-17e1-45d8-8047-ef5132a2ed9b",
      "custom_4a18bb49-36b0-442b-a617-9146cb9d344a",
      "custom_ccae5992-16d7-4492-abc4-0ccc0569235c",
      "custom_86da08e7-49a8-494e-b330-9f3e7faf756d",
      "custom_ae6ab09e-5fd1-4dc9-87de-292339ea1388",
      "custom_39714e35-5fae-432e-9bf8-7cab6fdd048d",
      "custom_bbfb616c-7ef5-458e-b2ee-f62be93b25c2",
      "custom_9c26a789-fbd1-4487-9f69-a8a20625aca9",
      "custom_a35563c5-0232-4c36-80fc-8925b3b13910",
      "custom_11559b4a-51d9-4343-96a2-3a4e151c80b2",
      "custom_e65a5a53-a4e5-4931-abeb-32b00852ad4a",
      "custom_76823493-eccb-4049-8b45-262194da87e6",
      "custom_007743f4-1348-4400-9d8c-369a6bb9c505",
      "custom_0551ad4a-3654-4cf0-b18c-82c4b7d8434c",
      "custom_4d6f6556-6854-4ae8-baa4-311398f546e8",
      "custom_7c0db371-f7ba-47e5-82d6-03544c9c54b5",
      "custom_83457af3-ea96-48eb-b1ab-22e8f3586e34",
      "custom_cf03f851-2ca3-411c-aaa0-5d851fc208cd",
      "custom_29eaeff8-67a7-4174-a29b-0d30098d647b",
      "custom_5da2faae-9d56-408d-9dc5-b65bda942734",
      "custom_210e779d-1cb0-49a9-8544-4661e6672b39",
      "custom_1baae0fc-2427-410f-9e00-496a756772df",
      "custom_53505aa5-9be3-4f0e-851b-f9fd5c6d026b",
      "custom_d0183d22-0b9d-4895-8889-2567b45fd90e",
      "custom_ba306fd4-b9e6-461d-8e6c-bf948eae82c4",
      "custom_75f025c9-6112-4ccf-aebe-a346ceb524eb",
      "custom_af625cbd-9152-4ed5-ba48-bc6fb3a2181b",
      "custom_3799de94-7466-4956-b8c9-c908a484d4f7",
      "custom_bef2517d-6a7c-4e7e-8eb6-9c9783b388a4",
      "custom_9f542a7d-44fb-4419-92fe-9fd4aec03c74",
      "custom_5503a329-a6c3-4409-8b76-c39ea9162d17",
      "custom_106a5140-4817-42d2-ba66-49546bdcd3c2",
      "custom_cca7677e-3e4b-4e56-b8bc-174845f0fdc7",
      "custom_3d56ff79-e4c7-42dd-916f-d4a07447667a",
      "custom_f5be979e-5744-441b-9e6a-fc546ce745a8",
      "custom_fb2a1824-ed63-4345-96a5-062a9a2aaf75",
      "custom_ec42de81-9899-435a-87ab-b4fbbda722eb",
      "custom_ea07c41f-e65c-4a97-b3a4-2ea8699f7673"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
